import PublicCapBu from "pages/public-capbu/PublicCapBu";

export default PublicCapBu